import axios from 'axios'
import { config } from '../Config/config'

const bankService = {

    getAllBank: () => {
        const result = axios.get(config.apiUrl + '/bank')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }

            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    addBank: (data) => {
        const result = axios.post(config.apiUrl + '/bank', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getBankID: (id) => {
        const result = axios.get(config.apiUrl + '/bankID/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    EditBank: (data) => {
        const result = axios.put(config.apiUrl + '/bank', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    
    //delete data
    deleteBank: (id) => {
        const result = axios.delete(config.apiUrl + '/bank/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    softDeleteBank: (data) => {
        const result = axios.put(config.apiUrl + '/bankdel', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllFilterBank: (filter) => {
        const result = axios.post(config.apiUrl + '/bankFilter', filter)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }

            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    
    countBank: () => {
        const result = axios.get(config.apiUrl + '/countbank')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    }

}

export default bankService